import { ICommand } from 'core-ts-types';
import { CourseSlot, Slot } from './../global/builders/ap_generic_slot_builder';
import { APTerm } from './../global/builders/ap_term_builder';
import { ApMarkAsMetModelRoutes } from './mark_as_met_unmet_routes';

interface ICourseDetailsStateParam {
  courseNk: string;
  programSlotId?: CourseSlot['programSlot']['id'];
  slotType: CourseSlot['programSlot']['slot_type'] | null;
  title: CourseSlot['title'];
  termId: APTerm['id'] | null;
  isFromSmartCat?: boolean;
}
export interface ICourseDetailsStateParams {
  courseNk: string;
  courseId: number;
  termId: number;
  slotId: number;
  isPast: boolean;
  showCourseDetailsMenu: boolean;
  plannedCourseId: number;
  status?: string;
}

export interface ICourseDetailState extends ng.ui.IState {
  data: {
    pageTitle: string;
    allowSourceFocus: boolean;
  };
  params: {
    courseDetails: ICourseDetailsStateParam;
  };
}

export const courseDetailState: ICourseDetailState = {
  // url: '/course_details',
  data: {
    pageTitle: 'Course details',
    allowSourceFocus: true
  },
  params: {
    courseDetails: {} as ICourseDetailsStateParam
  },
  resolve: {
    clearCourseInfo: (clearCourseInfoCommand: ICommand) => clearCourseInfoCommand()
  }
};

const studentCourseDetailState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@my.planner.plan': {
      template: `<ap-course-details></ap-course-details>`
    }
  }
};

export const ApModelRoutes = {
  'my.planner.plan.course_details': { ...studentCourseDetailState },
  'my.planner.plan.default.course_details': { ...studentCourseDetailState },
  'my.planner.plan.coursegroup.course_details': { ...studentCourseDetailState },
  ...ApMarkAsMetModelRoutes
};

export const MultiApModelRoutes = {
  'my.planner.multiplan.default.course_details': {
    data: {
      pageTitle: 'Course details',
      allowSourceFocus: true
    },
    resolve: {
      clearCourseInfo: (clearCourseInfoCommand: ICommand) => clearCourseInfoCommand()
    },
    params: {
      courseDetailsParams: {
        courseNk: '-1',
        courseId: -1,
        termId: -1,
        slotId: -1,
        showCourseDetailsMenu: false
      }
    },
    views: {
      'right-panel-popout@my.planner.multiplan': {
        template: `<multi-ap-course-details></multi-ap-course-details>`
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/ap_course_details_routes.ts